import { useEffect, useState } from "react";
import { getApiAxios, postApiAxios } from "../utils/apiClient";

export type useFetchResponse<T> = {
    data: T;
    isLoading: boolean;
};

const useFetchByPostAction = <T>(url: string, param: any): useFetchResponse<T> => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [data, setData] = useState({});

    useEffect(() => {
        setIsLoading(true);
        const fetchData = async (): Promise<void> => {
            try {
                let data = await postApiAxios(url, param);
                setData(data);
            } catch (error) {
                throw error;
            } finally {
                setIsLoading(false);
            }
        };

        if (param !== null) {
            fetchData();
        } else {
            setIsLoading(false);
        }
    }, [url, param]);

    return { data: data as T, isLoading };
}

const useFetchByGetAction = <T>(url: string): useFetchResponse<T> => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [data, setData] = useState({});
    useEffect(() => {
        setIsLoading(true);
        const fetchData = async (): Promise<void> => {
            try {
                let data = await getApiAxios(url, null);
                setData(data);
            }
            catch (error) {
                throw error;
            }
            setIsLoading(false);
        };
        fetchData();
    }, [url]);
    return { data: data as T, isLoading };
}

export { useFetchByPostAction, useFetchByGetAction };